import React from 'react';
import { aboutData } from '../data/mock';

export const About = () => {
  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-cyan-50/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            {aboutData.title}
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-6 whitespace-pre-line text-left">
            {aboutData.description}
          </p>
          {aboutData.vision && (
            <div className="bg-gradient-to-r from-cyan-500/10 to-teal-500/10 border-l-4 border-cyan-500 p-6 rounded-r-lg">
              <p className="text-lg text-gray-800 font-medium italic">
                {aboutData.vision}
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
